module.exports = __webpack_public_path__ + "img/culture1.4d1ce33c.jpg";